import { render, staticRenderFns } from "./HeadingBlock.vue?vue&type=template&id=47e74869&scoped=true&"
import script from "./HeadingBlock.vue?vue&type=script&lang=ts&"
export * from "./HeadingBlock.vue?vue&type=script&lang=ts&"
import style0 from "./HeadingBlock.vue?vue&type=style&index=0&id=47e74869&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e74869",
  null
  
)

export default component.exports